import { render, staticRenderFns } from "./Prepa.vue?vue&type=template&id=22e89dbb&"
import script from "./Prepa.vue?vue&type=script&lang=js&"
export * from "./Prepa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports